/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function UpdateBatchDataEntryLinkRequestUpdatesFromJSON(json) {
    return UpdateBatchDataEntryLinkRequestUpdatesFromJSONTyped(json, false);
}
export function UpdateBatchDataEntryLinkRequestUpdatesFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        filterTagIds: !exists(json, 'filterTagIds') ? undefined : json['filterTagIds'],
        versionIds: !exists(json, 'versionIds') ? undefined : json['versionIds'],
        intervalStart: !exists(json, 'intervalStart') ? undefined : new Date(json['intervalStart']),
        intervalEnd: !exists(json, 'intervalEnd') ? undefined : new Date(json['intervalEnd']),
        duration: !exists(json, 'duration') ? undefined : json['duration'],
    };
}
export function UpdateBatchDataEntryLinkRequestUpdatesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        filterTagIds: value.filterTagIds,
        versionIds: value.versionIds,
        intervalStart: value.intervalStart === undefined ? undefined : value.intervalStart.toISOString().substr(0, 10),
        intervalEnd: value.intervalEnd === undefined ? undefined : value.intervalEnd.toISOString().substr(0, 10),
        duration: value.duration,
    };
}
